import React from "react";
import classNames from "classnames";
import { toggleSidebar } from "../../redux/actions/sidebarActions";
import { isLocal } from "../../utils/env";

// State management
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../../redux/actions/userActions";

import {
  Row,
  Col,
  Collapse,
  Navbar,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ListGroup,
  ListGroupItem,
  Form,
  Input,
} from "reactstrap";

import NavBarAccountDropdown from "./NavBar.AccountDropdown";
import NavBarAlertsDropdown from "./NavBar.AlertsDropdown";
import NavBarLanguageDropdown from "./NavBar.LanguagesDropDown";

const USE_ALERTS = false;
const USE_LANGUAGES = false;

const NavbarDropdown = ({ children, count, showBadge, header, footer, icon: Icon }) => (
  <UncontrolledDropdown nav inNavbar className="mr-2">
    <DropdownToggle nav className="nav-icon dropdown-toggle">
      <div className="position-relative">
        <Icon className="align-middle" size={18} />
        {showBadge ? <span className="indicator">{count}</span> : null}
      </div>
    </DropdownToggle>

    <DropdownMenu right className="dropdown-menu-lg py-0">
      <div className="dropdown-menu-header position-relative">
        {count} {header}
      </div>
      <ListGroup>{children}</ListGroup>
      <DropdownItem header className="dropdown-menu-footer">
        <span className="text-muted">{footer}</span>
      </DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);

const NavbarDropdownItem = ({ icon, title, description, time, spacing }) => (
  <ListGroupItem>
    <Row noGutters className="align-items-center">
      <Col xs={2}>{icon}</Col>
      <Col xs={10} className={spacing ? "pl-2" : null}>
        <div className="text-dark">{title}</div>
        <div className="text-muted small mt-1">{description}</div>
        <div className="text-muted small mt-1">{time}</div>
      </Col>
    </Row>
  </ListGroupItem>
);

const NavbarComponent = ({ user, logoutUser, toggleSidebar }) => {
  return (
    <Navbar color="white" light expand>
      <span className="sidebar-toggle d-flex mr-2" onClick={toggleSidebar}>
        <i className="hamburger align-self-center" />
      </span>

      {/* https://mbroadcast.atlassian.net/browse/DE-103 */}
      <Form inline className={classNames({ "d-none": !isLocal() })}>
        <Input
          type="text"
          placeholder="Search site..."
          aria-label="Search"
          className="form-control-no-border mr-sm-2"
        />
      </Form>

      <Collapse navbar>
        <Nav className="ml-auto" navbar>
          {USE_ALERTS && (
            <NavBarAlertsDropdown
              NavbarDropdown={NavbarDropdown}
              NavbarDropdownItem={NavbarDropdownItem}
            />
          )}

          {USE_LANGUAGES && <NavBarLanguageDropdown />}

          <NavBarAccountDropdown user={user} logoutUser={logoutUser} />
        </Nav>
      </Collapse>
    </Navbar>
  );
};

NavbarComponent.propTypes = {
  user: PropTypes.object.isRequired,
  logoutUser: PropTypes.func.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps, { logoutUser, toggleSidebar })(NavbarComponent);
